var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-progress-bar'),_c('router-view'),_c('toast',{attrs:{"is-open":_vm.isToastOpen,"toast":_vm.toast},on:{"closeToast":_vm.closeToast}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }